import { Button, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { ISelectedConversation } from "../../types/SelectedConversation";
import AddressInfo from "../Conversations/components/Accounts/AddressInfo";
import { useCallback } from "react";
import { AbuseReport } from "../AbuseReport";

type HeaderProps = {
  conversation: ISelectedConversation;
  setConversation: React.Dispatch<
    React.SetStateAction<ISelectedConversation | null>
  >;
};

export const Header = ({ conversation, setConversation }: HeaderProps) => {
  const back = useCallback(() => setConversation(null), [setConversation]);

  return (
    <Row className="align-center profile-header">
      <Button
        shape="circle"
        icon={<ArrowLeftOutlined />}
        size="large"
        className="back-btn mr-6 back-btn"
        onClick={back}
      />
      <Row className="messages-header mr-6">
        <h3 className="customer-title">{conversation.name}</h3>
        <Row>
          <AddressInfo
            propertyAddress={conversation.propertyAddress}
            contractNumber={conversation.contractNumber}
            isConvLabel={false}
          />
        </Row>
      </Row>
      <AbuseReport conversationId={conversation.id} />
    </Row>
  );
};
